import React, {useState, useEffect} from 'react';
import {
  FlatList,
  SafeAreaView,
  StatusBar,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ActivityIndicator,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons'; 





const wait = timeout => {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
};

export default function duvidas({navigation}) {
 
  
 
  


  return (
   <View>
    <TouchableOpacity style={{backgroundColor:'#01150E'}} >
      <View>
     
     <TouchableOpacity onPress={()=>navigation.navigate('eseguro')}>
     <View style={{flexDirection:'row',margin:20,borderBottomColor:'white',borderBottomWidth:1}}>
      <Ionicons name="newspaper-outline" size={24} color="black" color="white"/>
      <Text style={styles.title}>É seguro?</Text>
      </View> 
     </TouchableOpacity>
      
     <TouchableOpacity onPress={()=>navigation.navigate('ComoTrocar')}>
     <View style={{flexDirection:'row',margin:20,borderBottomColor:'white',borderBottomWidth:1}}>
      <Ionicons name="newspaper-outline" size={24} color="black" color="white"/>
      <Text style={styles.title}>Como Trocar?</Text>
      </View> 
     </TouchableOpacity>

     <TouchableOpacity onPress={()=>navigation.navigate('Receber')}>
     <View style={{flexDirection:'row',margin:20,borderBottomColor:'white',borderBottomWidth:1}}>
      <Ionicons name="newspaper-outline" size={24} color="black" color="white"/>
      <Text style={styles.title}>Como recebo meu dinheiro?</Text>
      </View> 
     </TouchableOpacity>
      
     <TouchableOpacity onPress={()=>navigation.navigate('Recusado')}>
     <View style={{flexDirection:'row',margin:20,borderBottomColor:'white',borderBottomWidth:1}}>
      <Ionicons name="newspaper-outline" size={24} color="black" color="white"/>
      <Text style={styles.title}>Cartão recusado o que fazer?</Text>
      </View> 
     </TouchableOpacity>

      
       {/**/}  
      
      </View>
     
  
     
    </TouchableOpacity>
   </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: StatusBar.currentHeight || 0,
  },
  item: {
    padding: 20,
    marginVertical: 8,
    marginHorizontal: 16,
  },
  title: {
    fontSize: 20,
    color:'white',
    margin:5,
    borderRadius:16
  },
});